module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("GyjEb"))).then(() => module.bundle.root('ljYL6'));